import type { UseQueryResult } from "@tanstack/react-query";
import { createContext, type ReactNode, useContext } from "react";
import type { FamilyDocument } from "@/generated/backend/v1/family";
import type { StoredPlan } from "@/generated/backend/v1/plan";
import type { User } from "@/generated/backend/v1/user";

/** The three server documents every app page reads, loaded once by the shell. */
export type AppData = {
  user: UseQueryResult<User>;
  family: UseQueryResult<FamilyDocument | null>;
  plan: UseQueryResult<StoredPlan | null>;
};

const Ctx = createContext<AppData | null>(null);

export function AppDataProvider({ children, ...data }: AppData & { children: ReactNode }) {
  return <Ctx.Provider value={data}>{children}</Ctx.Provider>;
}

export function useAppData(): AppData {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useAppData must be used inside the app shell");
  return ctx;
}
